const AUTH_KEYS = {
  USER_PROFILE: () => ['auth', 'profile'],
  INVITATION: (uid) => ['auth', 'invitation', uid],
  DEFERRED_LOGIN: () => ['auth', 'deferred-login'],
};

export default AUTH_KEYS;
